import { useAppDispatch, useAppSelector } from '~/store/redux-hook';

import { playlistSlice } from './playlistSlice';

export const usePlaylistsSelector = () => {
  return useAppSelector((state) => state.playlist.playlists);
};

export const useSelectedPlaylistIdSelector = () => {
  return useAppSelector((state) => state.playlist.selectedPlaylistId);
};

export const useSetSelectedPlaylistIdValue = () => {
  const dispatch = useAppDispatch();

  return (payload: string | null) => {
    dispatch(playlistSlice.actions.setSelectedPlaylistId(payload));
  };
};
